"use client";

import React from "react";
import { Calendar, Globe, Package, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  icon: ShieldCheck,
  value: "$45M+",
  label: "Total Financed"
}, {
  icon: Globe,
  value: "1,200+",
  label: "Homes Listed"
}, {
  icon: Package,
  value: "12%",
  label: "Avg. Down Payment"
}, {
  icon: Calendar,
  value: "24/7",
  label: "Market Support"
}];
export default function MarketSnapshot() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="265193" id="market-snapshot" className="bg-background text-foreground py-16 md:py-24 px-4 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-accent/10 via-background to-background pointer-events-none" />

      <div className="container mx-auto max-w-7xl relative z-10">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:gap-y-8 lg:divide-x divide-border/30 bg-card/60 rounded-2xl border border-border/50 backdrop-blur-sm shadow-xl overflow-hidden">
            {stats.map((stat, i) => {
            const Icon = stat.icon;
            return <div key={i} data-index={i} className="flex flex-col items-center justify-center p-8 md:p-10 text-center group hover:bg-accent/5 transition-colors duration-300">
                  <div className="mb-5 p-3 rounded-lg bg-background/80 border border-border/50 shadow-md group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-accent-foreground opacity-90" />
                  </div>
                  
                  <h3 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-primary mb-3 drop-shadow-sm tracking-tighter">
                    {stat.value}
                  </h3>
                  
                  <p className="text-sm md:text-base font-sans text-secondary uppercase tracking-widest font-semibold">
                    {stat.label}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}